export type ISaveAndGotoSubCard = (
  theForm: HTMLFormElement | JQuery<HTMLFormElement>,
  subAction: string,
  subFormId: string,
  subDataBundleUUID: string,
  subPageId: string,
  singlePage: boolean,
  deleteChildMessage?: string
) => void;

export function saveAndGotoSubCard(
  theForm: HTMLFormElement | JQuery<HTMLFormElement>,
  subAction: string,
  subFormId: string,
  subDataBundleUUID: string,
  subPageId: string,
  singlePage: boolean,
  deleteChildMessage?: string
): void {
  // Pass in a delete message, or use global var formRemoveSubDataBundleMsg, or check langObj for message
  const { langObj = {} } = window.DexeroCoreApp.userOptions;
  const _message = deleteChildMessage || langObj.confirmSubCardDeleteText;
  if (subAction === 'remove' && !window.confirm(_message)) {
    return;
  }
  $(':input[name=subAction]').val(subAction);
  $(':input[name=subFormId]').val(subFormId);
  $(':input[name=subDataBundleUUID]').val(subDataBundleUUID);
  $(':input[name=subPageId]').val(subPageId);
  $(':input[name=singlePage]').val(`${singlePage}`);
  ($(theForm)[0] as HTMLFormElement).submit();
}
